var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1929 8.18242C19.0516 8.29043 16.5579 9.67537 16.5579 12.7549C16.5579 16.3168 19.7311 17.577 19.8261 17.6082C19.8115 17.685 19.322 19.3339 18.153 21.0141C17.1107 22.4926 16.0221 23.9688 14.3661 23.9688C12.71 23.9688 12.2838 23.0207 10.3721 23.0207C8.50907 23.0207 7.84666 24 6.33188 24C4.8171 24 3.76016 22.6319 2.54493 20.9517C1.1373 18.9787 0 15.9136 0 13.0045C0 8.33843 3.07827 5.86379 6.10783 5.86379C7.71759 5.86379 9.05946 6.90549 10.0701 6.90549C11.0321 6.90549 12.5322 5.80138 14.3636 5.80138C15.0577 5.80138 17.5515 5.86379 19.1929 8.18242ZM13.4942 3.82598C14.2516 2.94029 14.7874 1.71137 14.7874 0.482448C14.7874 0.312031 14.7728 0.139214 14.7411 0C13.5088 0.0456046 12.0427 0.808881 11.1587 1.81938C10.4646 2.59706 9.81685 3.82598 9.81685 5.07171C9.81685 5.25893 9.84851 5.44614 9.86312 5.50615C9.94105 5.52055 10.0677 5.53735 10.1943 5.53735C11.3 5.53735 12.6905 4.80768 13.4942 3.82598Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.227e5d1e.svg";
export { ForwardRef as ReactComponent };